import { BusinessRequesterInfo, CustomerRequesterInfo, RequesterInfoType, MaritimeRequesterInfo } from "./RequesterInfo";

// TODO: 置き場とファイルの内容整理
// 判別用 Type Guard: MaritimeRequesterInfo かどうか
export function isMaritimeRequesterInfo(value: any): value is MaritimeRequesterInfo {
  return !!value && typeof value === "object" && (
    value.type === "MaritimeRequesterInfo"
    || value.type === RequesterInfoType?.MaritimeRequesterInfo
  )
};

// 判別用 Type Guard: BusinessRequesterInfo かどうか
export function isBusinessRequesterInfo(value: any): value is BusinessRequesterInfo {
  return !!value && typeof value === "object" && (
    value.type === "BusinessRequesterInfo"
    || value.type === RequesterInfoType?.BusinessRequesterInfo
  )
};

// 判別用 Type Guard: CustomerRequesterInfo かどうか
export function isCustomerRequesterInfo(value: any): value is CustomerRequesterInfo {
  return !!value && typeof value === "object" && (
    value.type === "CustomerRequesterInfo"
    || value.type === RequesterInfoType?.CustomerRequesterInfo
  );
};

// アサーション関数
export function assertMaritimeRequester(value: any): asserts value is MaritimeRequesterInfo {
  if (!isMaritimeRequesterInfo(value)) {
    throw new Error("Value is not MaritimeRequesterInfo");
  };
};

export function assertBusinessRequester(value: any): asserts value is BusinessRequesterInfo {
  if (!isBusinessRequesterInfo(value)) {
    throw new Error("Value is not BusinessRequesterInfo");
  };
};

export function assertCustomerRequester(value: any): asserts value is CustomerRequesterInfo {
  if (!isCustomerRequesterInfo(value)) {
    throw new Error("Value is not CustomerRequesterInfo");
  };
};